import React from "react";
import styles from "./PrivacyPolicy.module.css";

const TermsAndCondition = () => (
  <div className={styles.privacyContainer}>
    <h1 className={styles.heading}>Terms and Conditions</h1>
    <p className={styles.intro}>
      These terms and conditions apply to the Greenrock Creations website and
      its subsidiaries and affiliates (collectively the "Site") and other
      websites that expressly incorporate these Conditions ("Conditions"). In
      some instances, a particular Greenrock Creations product purchased through
      the Site may be subject to additional policies, guidelines, terms, and/or
      agreements ("Terms"). In the event that such Terms are inconsistent with
      these Conditions, the Terms shall govern. BY VISITING AND/OR USING THIS
      SITE IN ANY WAY, SUCH AS BROWSING PRODUCTS OR PLACING AN ORDER, YOU AGREE
      TO THESE TERMS AND CONDITIONS. Please read these Conditions carefully. If
      you do not wish to be bound by these Conditions, do not access or use the
      Greenrock Creations Site.
    </p>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Change of Terms</h2>
      <p>
        Greenrock Creations may, at its sole discretion, revise or add new terms
        to these Conditions from time to time without notice to you. Such
        revisions and additions shall be deemed effective immediately upon
        notice, which Greenrock Creations may give by any means, including,
        without limitation, by posting the revised Conditions on the Greenrock
        Creations Site. You are responsible for reviewing the Greenrock
        Creations Site for any modifications to these Conditions that may affect
        your rights or obligations. Any change or modification will be effective
        immediately upon posting of the revisions on the Site. Any access or use
        by you of the Greenrock Creations Site after changes to these Conditions
        will constitute your acceptance of the revised terms. If you do not
        agree to the amended terms, you must stop using the Site.
      </p>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Content</h2>
      <p>
        The Site and all content and other materials, including, without
        limitation, text, icons, graphics, logos, images, designs, pictures,
        selection, coordination, "look and feel", information, data, sound
        files, and other files and software is the proprietary property of
        Greenrock Creations or its affiliates, licensors or users and is
        protected by United States and international trade dress, copyright
        laws, patent and trademark laws, and various other intellectual property
        rights and unfair competition laws. Copyright in the documents and
        material on the Greenrock Creations Site is owned by or licensed to
        Greenrock Creations. You are authorized to use this material only for
        personal, non-commercial purposes. You may download, print, and store
        copies of this material for your own personal, non-commercial use.
        Nothing contained on the Greenrock Creations Site should be construed as
        granting, by implication or otherwise, any license or right to use any
        trademark or service mark displayed on the Greenrock Creations Site
        without the written permission of Greenrock Creations or any third party
        that may own such trademarks or service marks. Greenrock Creations will
        aggressively enforce its intellectual property rights to the fullest
        extent of the law.
      </p>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Trademarks</h2>
      <p>
        Greenrock Creations, the Greenrock Creations logos, and any other
        product or service name or slogan contained in our Site are trademarks
        of Greenrock Creations and/or its licensors, and may not be copied,
        imitated or used, in whole or in part, without the prior written
        permission of Greenrock Creations or the applicable trademark holder.
        You may not use any metatags or any other "hidden text" utilizing
        "Greenrock Creations" or any other name, trademark or product or service
        name of Greenrock Creations without our prior written permission. All
        other trademarks, registered trademarks, product names and Greenrock
        Creations names or logos mentioned in our Site are the property of their
        respective owners.
      </p>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Use of the Site</h2>
      <ul className={styles.list}>
        <li>
          You are granted a personal, limited, non-sublicensable license to
          access and use the Site and electronically copy, and print to hard
          copy portions of the Site materials for your informational,
          non-commercial and personal use only.
        </li>
        <li>
          Such license does not include: (a) any resale or commercial use of our
          Site or the Site materials therein; (b) the collection and use of any
          product listings, pictures or descriptions for commercial purposes;
          (c) the distribution, public performance or public display of any Site
          materials, (d) modifying or otherwise making any derivative uses of
          our Site and the Site materials, or any portion thereof; (e) use of
          any automated means to access, monitor or interact with any portion of
          our Site, including through data mining, robots, spiders, scraping, or
          similar data gathering or extraction methods; (f) downloading (other
          than the page caching) of any portion of our Site, the Site materials
          or any information contained therein, except as expressly permitted on
          our Site; (g) cause to appear any pop-up, pop-under, exit windows,
          expanding buttons, banners, advertisement, or anything else which
          minimizes, covers, or frames or inhibits the full display of our Site;
          (h) use our web sites in any way which interferes with the normal
          operation of our sites; or (i) any use of our Site or the Site
          materials other than for its intended purpose.
        </li>
        <li>
          Any use of our Site or the Site materials other than as specifically
          authorized herein, without the prior written permission of Greenrock
          Creations, is strictly prohibited and will terminate the license
          granted herein. Such unauthorized use may also violate applicable
          laws, including without limitation copyright and trademark laws and
          applicable communications regulations and statutes. Unless explicitly
          stated herein, nothing in these Conditions shall be construed as
          conferring any license to intellectual property rights, whether by
          estoppel, implication, or otherwise. This license is revocable at any
          time.
        </li>
      </ul>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Information on our website</h2>
      <p>
        Greenrock Creations is committed to providing current and accurate
        information on our web sites, email, chat, and telephone communications.
        We do not, however, warrant that this information is always correct,
        accurate or complete. In rare circumstances, data, including prices, may
        be inaccurately displayed on our Site due to system and typographical
        errors which may occur. Inadvertent errors or inaccurate advertised
        prices are not binding on Greenrock Creations, and may be adjusted by
        Greenrock Creations at any time. Greenrock Creations reserves the right
        to correct any and all errors when they do occur. If an order is placed
        with a lower product's listed price than the actual price, Greenrock
        Creations will, at its discretion, either advise the customer before
        shipping the product or cancel the order and notify the customer of such
        cancellation. Greenrock Creations apologizes for any inconvenience that
        this may cause.
      </p>
      <p>
        Information that we communicate is not a binding contract, and should
        not be treated as such. The sole remedy of a customer acting on
        incorrect information is to request a cancellation of the order placed
        as a result of this incorrect information. If an order has been shipped,
        the customer agrees to either return the product for full credit or pay
        the difference between the actual and charged prices. Please review our
        Return Policies.
      </p>
      <p>
        Greenrock Creations' product details and prices are also subject to
        change without notice. All of our prices are final and non-negotiable.
        Additionally, in order to conserve natural resources, and maintain the
        high quality of our pieces, Greenrock Creations does not allow multiple
        pieces to be purchased for comparison, which is the act of buying
        several items with the intent of keeping the item that you like best and
        returning the remaining items that were purchased. If you have any
        questions regarding our policy, please contact our Customer Service at{" "}
        <a className={styles.link} href="mailto:info@greenrockcreations.com">
          info@greenrockcreations.com
        </a>
        .
      </p>
      <p>
        All representations including representations regarding gemstone origin,
        recycled content of precious metals, and estate information, are
        provided to the best of Greenrock Creations' knowledge and without
        guarantee or warranty of any kind.
      </p>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Your account and order</h2>
      <p>
        When you access or use the Greenrock Creations website or your
        personalized Greenrock Creations account, you are solely responsible for
        maintaining the confidentiality of your account and for restricting
        access to your computer. You are further responsible for all activities
        that occur under your personal account and your password. If you are
        under the age of 18 years old, you may use our only under the guidance
        and direction of a parent or guardian. Please note that Greenrock
        Creations reserves the right, in its sole discretion, to refuse service,
        terminate accounts, remove or edit content or cancel orders.
      </p>
      <p>
        In the case where a customer files a chargeback, Greenrock Creations has
        the right to recover its direct and indirect costs, and cancel any
        promotional items, free shipping, or other benefits, as determined in
        Greenrock Creations' sole and absolute discretion.
      </p>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Certificate of Authenticity</h2>
      <p>
        When you order a loose gemstone or jewelry piece, Greenrock Creations
        will ship it to you with the accompanying certificate of authenticity or
        grading report, if applicable. These grading reports are detailed
        documents created by experts at highly-respected laboratories. These
        grading reports are extremely expensive to replace and as a result of
        this, Greenrock Creations requires each grading report to be included
        with each returned item. If you do not include the grading report with
        your return, you will be charged a replacement fee.
      </p>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Passage of Title</h2>
      <p>
        Title for goods purchased passes from Greenrock Creations to the
        purchaser's designee at the time that goods are delivered to the
        designee.
      </p>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Signature Requirement</h2>
      <p>
        For your protection, Greenrock Creations may require a signature upon
        delivery of your order.
      </p>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Disclaimer of Warranties</h2>
      <div className={styles.disclaimer}>
        THIS SITE, THE CONTENT CONTAINED THEREIN AND THE PRODUCTS PROVIDED IN
        CONNECTION THEREWITH (THE "PRODUCTS") ARE PROVIDED ON AN 'AS IS' AND 'AS
        AVAILABLE' BASIS. GREENROCK CREATIONS MAKES NO REPRESENTATIONS OR
        WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, AS TO THE OPERATION
        OF THIS SITE OR THE INFORMATION, CONTENT, MATERIALS OR PRODUCTS INCLUDED
        ON IT. YOU EXPRESSLY AGREE THAT YOUR USE OF THIS SITE IS AT YOUR SOLE
        RISK, BY YOUR OWN FREE WILL, AND THAT YOU ARE SOLELY RESPONSIBLE FOR ANY
        CONSEQUENCES ARISING FROM THIS USE. WITHOUT LIMITING THE FOREGOING,
        GREENROCK CREATIONS DISCLAIMS ALL WARRANTIES, WHETHER EXPRESSED OR
        IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF
        MERCHANTABILITY AND/OR FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND
        NON-INFRINGEMENT AS TO THE INFORMATION, CONTENT, AND MATERIALS ON THE
        SITE. GREENROCK CREATIONS DOES NOT WARRANT THAT THIS SITE, ITS SERVERS,
        OR ITS ELECTRONIC COMMUNICATION ARE ACCURATE, RELIABLE, COMPLETE,
        CURRENT OR FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
      </div>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Limitation of Liability</h2>
      <div className={styles.limitation}>
        IN NO EVENT SHALL GREENROCK CREATIONS, ITS DIRECTORS, MEMBERS,
        EMPLOYEES, AFFILIATES, OR AGENTS OR ANY OTHER PARTY INVOLVED IN
        CREATING, PRODUCING, OR DELIVERING THE GREENROCK CREATIONS PRODUCTS BE
        LIABLE TO YOU OR ANY THIRD PARTY FOR DAMAGES OF ANY KIND ARISING FROM
        THE USE OF THIS SITE, INCLUDING, BUT NOT LIMITED TO DIRECT, INDIRECT,
        INCIDENTAL, SPECIAL, PUNITIVE AND CONSEQUENTIAL DAMAGES OR OTHER DAMAGES
        OF ANY KIND, INCLUDING BUT NOT LIMITED TO LOSS OF USE, LOSS OF PROFITS,
        OR LOSS OF DATA, WHETHER IN CONTRACT, TORT, OR OTHERWISE, INCLUDING
        NEGLIGENCE, ARISING OUT OF OR IN ANY WAY CONNECTED WITH OR RESULTING
        FROM THE USE OF OUR SITE, THE PRODUCTS, THE SERVICES OR THE CONTENT
        CONTAINED IN OR ACCESSED THROUGH THE GREENROCK CREATIONS SITE, OR THAT
        RESULTS FROM THE RELIANCE BY USER ON ANY INFORMATION OBTAINED FROM
        GREENROCK CREATIONS, INCLUDING ANY ERROR OR OMISSION REGARDING LISTED
        GEMSTONE ORIGIN, ANY MISTAKES, OMISSIONS, INTERRUPTIONS, DELETION OF
        FILES OR EMAILS, ERRORS, DEFECTS, VIRUSES, DELAYS IN OPERATION OR
        TRANSMISSION OR ANY FAILURE OF PERFORMANCE OF THE GREENROCK CREATIONS
        SITE, WHETHER OR NOT RESULTING FROM ACTS OF GOD, COMMUNICATIONS FAILURE,
        THEFT, DESTRUCTION OR UNAUTHORIZED ACCESS TO GREENROCK CREATIONS'
        PROGRAMS OR SERVICES, EVEN IF GREENROCK CREATIONS IS EXPRESSLY ADVISED
        OF THE POSSIBILITY OF SUCH DAMAGES, OR EVEN IF THE LOSS, DAMAGE OR
        EXPENSE WAS CAUSED BY GREENROCK CREATIONS, ITS DIRECTORS, MEMBERS,
        EMPLOYEES, AFFILIATES OR AGENTS. IN NO EVENT SHALL GREENROCK CREATIONS'
        LIABILITY BE GREATER THAN THE PRICE YOU PAID FOR THE PRODUCT OR SERVICE
        THAT IS THE BASIS FOR THE CLAIM.
        <br />
        <br />
        Some jurisdictions may not allow the exclusion of implied warranties, so
        some of the above exclusions may not apply to you. It is your
        responsibility to check local laws for any restrictions or limitations
        regarding the exclusions of implied warranties.
      </div>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Indemnification</h2>
      <p>
        You agree to defend, indemnify, and hold harmless Greenrock Creations,
        its independent contractors, service providers and consultants, and its
        parents, affiliates, and related entities and their respective
        directors, officers, employees, and agents from and against all claims,
        losses, damages, liabilities, expenses and costs (including without
        limitation reasonable attorneys' fees and court costs), arising out of
        or relating to your breach of these Conditions or your access to or use
        of the Greenrock Creations Site or inability to use the Site, including
        without limitation any actual or threatened suit, demand or claim made
        against Greenrock Creations and/or its independent contractors, service
        providers, employees, directors or consultants, arising out of or
        relating to the Content, your conduct, your violation of these Terms and
        Conditions or your violation of the rights of any third party.
      </p>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Links to other sites and services</h2>
      <p>
        Links to other Internet sites and services operated by third parties,
        including Greenrock Creations vendors, do not constitute sponsorship,
        endorsement, or approval by Greenrock Creations of the content,
        policies, or practices of such linked sites or services. Greenrock
        Creations is not responsible for the availability, content, security,
        policies, or practices of linked sites or services, including, without
        limitation, the accuracy of content on linked sites or services and the
        privacy policies and practices of linked sites and services.
      </p>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Termination</h2>
      <p>
        Notwithstanding any of these Conditions, Greenrock Creations reserves
        the right, without notice and in its sole discretion, to terminate your
        license to use this site, and to block or prevent your future access to
        and use of the Site.
      </p>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Miscellaneous</h2>
      <p>
        These Conditions contain the entire understanding of you and Greenrock
        Creations with respect to the subject matter hereof and supersede all
        prior agreements and understandings between you and Greenrock Creations
        with respect to the subject matter hereof. The failure of Greenrock
        Creations at any time to enforce any of the provisions of these
        Conditions will not be deemed or construed to be a waiver of any such
        provisions, or in any way to affect the right of Greenrock Creations to
        thereafter enforce each and every provision of these Conditions. No
        waiver by Greenrock Creations of any breach of any provision of these
        Conditions will be construed or deemed to be a waiver of any other
        subsequent breach. If any provision of these Conditions is declared
        invalid or otherwise determined to be unenforceable for any reason, such
        provision will be deemed to be severable from the remaining provisions
        of these Conditions, which will otherwise remain in full force and
        effect. Provisions concerning your rights and obligations which by the
        content of the provision operate after termination or which are
        necessary to enforce any right will survive any termination or
        expiration of these Conditions.
      </p>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Arbitration</h2>
      <p>
        These Conditions and your use of this Site shall be governed by and
        construed in accordance with the laws of the State of [Your State],
        without resort to its conflict of law provisions. You agree that any
        action at law or in equity or any dispute, claim or controversy arising
        out of or relating to these Conditions or the breach, termination,
        enforcement, interpretation or validity thereof or the use of the Site
        or purchases from the Site thereof, (collectively, "Claims") shall be
        resolved by binding arbitration, as described below, instead of in
        court, except that each party retains the right to bring an individual
        action in small claims court. You further agree that arbitration must be
        on an individual basis and that you are hereby waiving your right to
        join or consolidate Claims in arbitration or arbitrate any claims as a
        representative or member of a purported class. You acknowledge and agree
        that you are waiving the right to a trial by jury. This arbitration
        provision shall survive the termination of these Conditions, as well as
        any other contractual agreement that you have with the Company.
      </p>
      <p>
        You acknowledge and agree that, by agreeing to these Conditions, the
        Federal Arbitration Act ("FAA") shall govern the interpretation and
        enforcement of this provision and that any such arbitration must proceed
        with the American Arbitration Association ("AAA") or JAMS in [Your
        County, State], before a mutually agreed upon single arbitrator licensed
        to practice law. It will be conducted in accordance with the
        then-prevailing Arbitration Rules of the AAA and the arbitrator shall be
        bound by these Conditions. The arbitrator shall have authority to award
        or grant legal, equitable, and declaratory relief. Such arbitration
        shall be final and binding on the parties.
      </p>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Questions</h2>
      <p>
        If you have any questions, please do not hesitate to contact us at{" "}
        <a className={styles.link} href="mailto:info@greenrockcreations.com">
          info@greenrockcreations.com
        </a>
        .
      </p>
    </section>

    <div className={styles.updated}>Last updated: June 2024</div>
  </div>
);

export default TermsAndCondition;
